import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Close from "@material-ui/icons/Close";

// Template de referência para estruturar o "Prompt do Agente de IA" —
// puramente informativo (não é copiado automaticamente pro campo, o
// usuário lê e escreve o próprio prompt inspirado nisso).
const PROMPT_TEMPLATE = `NOME DO AGENTE: [Nome]

FUNÇÃO: Você é um agente especializado em [área]

OBJETIVO(S): Seu objetivo é [resultado mensurável]

PÚBLICO: Você atende [tipo de usuário]

CONTEXTO: [Empresa, processo, produtos, conceitos e sistemas envolvidos]

ESCOPO: Você deve
- [...]
- [...]
- [...]

FORA DO ESCOPO: Você não deve
- [...]
- [...]

ENTRADAS: Você poderá receber
- [...]
- [...]

FONTES: [fornecer links e urls aqui apenas]

PRIORIDADE: você deve considerar as seguintes prioridades na conversa com o usuário [prioridades]

PERMISSÕES: você possui permissão de
* [...]
* [...]

FLUXO DE EXECUÇÃO: você deve, preferencialmente, executar, da seguinte forma
1. Identifique a intenção.
2. Verifique se existem dados suficientes.
3. Consulte as fontes necessárias.
4. Valide consistência e permissões.
5. Execute ou proponha a ação.
6. Confirme o resultado.

REGRAS DE DECISÃO:
- Se [...], então [...]
- Se houver conflito entre fontes, [...]
- Nunca assumir [...]

TRATAMENTO DE INCERTEZA:
- Faça perguntas quando faltar [...]
- Não invente informações.
- Informe claramente limitações e premissas.

FORMATO DA RESPOSTA:
- Idioma: português brasileiro.
- Estilo: direto e técnico.
- Estrutura: [...]
- Sempre incluir [...]

SEGURANÇA:
- Não revelar [...]
- Não executar [...] sem confirmação.
- Aplicar as regras de acesso do usuário.

CRITÉRIOS DE CONCLUSÃO: A tarefa estará concluída quando
- [...]
- [...]

EXEMPLOS FUNCIONAIS PARA O AGENTE:
Entrada: [...]
Resposta ou ação esperada: [...]`;

const AiPromptInstructionsModal = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        Como estruturar o Prompt do Agente de IA
        <IconButton size="small" onClick={onClose}>
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
          Use esta estrutura como referência para escrever um prompt completo. Substitua os trechos entre [ ] pelo conteúdo real do seu agente.
        </Typography>
        <Typography
          component="pre"
          variant="body2"
          style={{
            whiteSpace: "pre-wrap",
            fontFamily: "monospace",
            backgroundColor: "#f5f5f5",
            // Fundo claro fixo nos dois modos, entao o texto tambem e fixo:
            // sem isso ele herda `text.primary`, que e branco no escuro.
            color: "#000",
            padding: 16,
            borderRadius: 8,
            margin: 0,
          }}
        >
          {PROMPT_TEMPLATE}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AiPromptInstructionsModal;
